import { Injectable } from '@angular/core';
import { ApiBaseService } from '../api-base.service';
import { Observable } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';

const BASE_URL = '/employees';

@Injectable({
  providedIn: 'root'
})
export class EmployeeConsultantsService extends ApiBaseService {


  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }
  detail(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}`), options?.params);
  }
  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }
  update(employeeId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${employeeId}`), data);
  }
  delete(employeeId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${employeeId}`));
  }

  detailWorkingProjects(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/working-projects`), options?.params);
  }

  listSpecialisations(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl('/employee-specialisations'), options?.params);
  }

  detailSpecialisation(specialtyId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/employee-specialisations/${specialtyId}`), options?.params);
  }

  listEmployeeSpecialisations(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/specialisations`), options?.params);
  }

  updateEmployeeSpecialisation(employeeId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${employeeId}/specialisations`), data);
  }

  listEmployeeJobs(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/jobs`), options?.params);
  }
  detailEmployeeJob(employeeId: number, employeeJobId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/jobs/${employeeJobId}`), options?.params);
  }
  createEmployeeJob(employeeId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${employeeId}/jobs`), data);
  }
  updateEmployeeJob(employeeId: number, employeeJobId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${employeeId}/jobs/${employeeJobId}`), data);
  }
  deleteEmployeeJob(employeeId: number, employeeJobId: number,): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${employeeId}/jobs/${employeeJobId}`));
  }

  listEmployeeDocuments(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/documents`), options?.params);
  }
  detailEmployeeDocuments(employeeId: number, documentId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/documents/${documentId}`), options?.params);
  }
  createEmployeeDocuments(employeeId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${employeeId}/documents`), formData);
  }
  updateEmployeeDocuments(employeeId: number, documentId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${employeeId}/documents/${documentId}`), data);
  }
  deleteEmployeeDocuments(employeeId: number, documentId: number,): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${employeeId}/documents/${documentId}`));
  }

  listNotes(employeeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${employeeId}/notes`), options?.params);
  }

  createNotes(employeeId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${employeeId}/notes`), data);
  }

  deleteNotes(employeeId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${employeeId}/notes/${sectionNoteId}`));
  }

}
